module.exports = __webpack_public_path__ + "media/img/uploads/search-result-03-3f406a9ced5715d8ed493ebd25e1d102.jpg";